import { render } from "./province-detail.vue?vue&type=template&id=3389c587"
import script from "./province-detail.vue?vue&type=script&lang=js"
export * from "./province-detail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__